/* eslint-disable no-unused-vars */
import { isArray, forIn } from 'lodash';

const DEFAULT_PLACE_HOLDER = '_';

const MaskTypes = {
    phone: {
        mask: [/[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
        validation: val => {
            return true;
        }
    },
    date: {
        mask: [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /[12]/, /[0-9]/, /[0-9]/, /[0-9]/]
    }
};
const convertMask = (mask = [], placeholderChar = DEFAULT_PLACE_HOLDER) => {
    if(!isArray(mask)) {
        throw new Error(
            'Text-mask:convertMaskToPlaceholder; The mask property must be an array.'
        );
    }

    if(mask.indexOf(placeholderChar) !== -1) {
        throw new Error(
            'Placeholder character must not be used as part of the mask. Please specify a character ' +
                'that is not present in your mask as your placeholder character.\n\n' +
                `The placeholder character that was received is: ${JSON.stringify(
                    placeholderChar
                )}\n\n` +
                `The mask that was received is: ${JSON.stringify(mask)}`
        );
    }

    return mask
        .map(char => {
            return char instanceof RegExp ? placeholderChar : char;
        })
        .join('');
};

export default {
    bind: function(el, binding, vnode) {
        if(MaskTypes[binding.value]) {
            const mask = MaskTypes[binding.value].mask;

            el.addEventListener('keydown', (evt) => {
                const key = evt.key;
                const pos = el.value.length;
                const oldValue = el.value;
                const keyCode = evt.which;

                if(keyCode === 9 || keyCode === 37 || keyCode === 39) {
                    return;
                }

                if(key === 'Backspace') {
                    el.value = el.value.substr(0, el.value.length - 1);
                    if(!(mask[el.value.length] instanceof RegExp)) {
                        el.value = el.value.substr(0, el.value.length - 1);
                    }
                    return evt.preventDefault();
                }

                if(pos >= mask.length) {
                    return evt.preventDefault();
                }

                let cancel = false;

                const val = mask.map((char, maskIndex) => {
                    const isRexEx = char instanceof RegExp;

                    if(isRexEx) {
                        if(maskIndex < pos) {
                            const oldChar = oldValue.charAt(maskIndex);
                            if(char.test(oldChar)) {
                                return oldChar;
                            } else {
                                cancel = true;
                            }
                        }
                        if(maskIndex === pos) {
                            return (/\w/.test(key)) ? key : '';
                        }
                    } else {
                        return char;
                    }

                    return DEFAULT_PLACE_HOLDER;
                });

                if(!mask[pos].test(evt.key)) {
                    evt.preventDefault();
                }
            });
            el.addEventListener('keyup', (evt) => {
                const pos = el.value.length;
                const key = evt.key;

                if(key === 'Backspace') {
                    if(pos > 1) {
                        const mapChar = mask[pos];
                        const isRexEx = mapChar instanceof RegExp;
                    }
                }

                if(pos < mask.length) {
                    const mapChar = mask[pos];
                    const isRexEx = mapChar instanceof RegExp;
                    if(!isRexEx) {
                        el.value += mapChar;
                    }
                }
            });
            el.addEventListener('change', (evt) => {
                const phoneFormat = RegExp(/^(\d{3})-(\d{3})-(\d{4})$/);

                if(binding.value === 'phone') {
                    let isFormatted = phoneFormat.test(evt.target.value);

                    if(evt.target.value.length > 0 && !isFormatted) {
                        evt.target.value = evt.target.value.replace(/[^0-9]/g, '').replace(/^(\d{3})?(\d{3})?(\d{4})?/g, '$1-$2-$3');
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/input-mask.js